import MarketplaceOverview from "../Accueil/MarketplaceOverview";
import Pricing from "../Accueil/Marketplace";
import { useEffect, useContext, useState } from "react";
import { LanguageContext } from "../../../context/LanguageContext";
import TeqaConnectForm from "./TeqaConnectForm";

export default function MarketplacePage() {
  const { t, isRTL } = useContext(LanguageContext);
  const [isopenModal, setOpenModal] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main dir={isRTL ? "rtl" : "ltr"} className="bg-white">

      {/* HERO */}
      <section className="bg-gradient-to-r from-rose-600 to-pink-600 py-28">
        <div className="mx-auto max-w-5xl px-6 text-center text-white">
          <h1 className="text-5xl font-bold leading-tight">
            {t("marketplacePage.hero.title")}
            <br />
            {t("marketplacePage.hero.subtitle")}
          </h1>

          <p className="mt-6 text-lg opacity-90">
            {t("marketplacePage.hero.description")}
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:justify-center">
            <button 
                        onClick={() => setOpenModal(true)}
            className="rounded-xl bg-white px-8 py-4 font-semibold text-rose-600 hover:bg-gray-100">
              {t("marketplacePage.hero.merchantCta")}
            </button>

            {/* OPEN MODAL */}
            <button
              onClick={() => setOpenModal(true)}
              className="rounded-xl border border-white/40 px-8 py-4 font-semibold text-white hover:bg-white/10"
            >
              {t("marketplacePage.hero.partnerCta")}
            </button>
          </div>
        </div>
      </section>

      <MarketplaceOverview />
      <Pricing />

      {/* FINAL CTA */}
      <section className="bg-gray-900 py-24">
        <div className="mx-auto max-w-4xl px-6 text-center text-white">
          <h2 className="text-4xl font-bold">
            {t("marketplacePage.finalCta.title")}
          </h2>

          <p className="mt-4 text-lg text-gray-300">
            {t("marketplacePage.finalCta.description")}
          </p>

          <div className="mt-10 flex flex-col gap-4 sm:flex-row sm:justify-center">
            <button
            onClick={() => setOpenModal(true)}
            className="rounded-xl bg-rose-600 px-8 py-4 font-semibold hover:bg-rose-700">
              {t("marketplacePage.finalCta.merchant")}
            </button>

            {/* OPEN MODAL */}
            <button
              onClick={() => setOpenModal(true)}
              className="rounded-xl border border-gray-600 px-8 py-4 font-semibold hover:bg-gray-800"
            >
              {t("marketplacePage.finalCta.partner")}
            </button>
          </div>
        </div>
      </section>

      {/* MODAL */}
      <TeqaConnectForm
        isOpen={isopenModal}
        onClose={() => setOpenModal(false)}
      />
    </main>
  );
}
